module.exports = __webpack_public_path__ + "img/fuoristrada.5791d940.svg";